// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg fill=%27black%27 height=%2724%27 viewBox=%270 0 24 24%27 width=%2724%27 xmlns=%27http://www.w3.org/2000/svg%27><path d=%27M7 10l5 5 5-5z%27/><path d=%27M0 0h24v24H0z%27 fill=%27none%27/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.case-detail-container {
  background: #fff;
}
.case-detail-container .case-detail-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 10px;
}
.case-detail-container .case-detail-header .caseheader-label {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  padding-left: 20px;
  width: 100%;
}
.case-detail-container .case-detail-header .caseheader-label .expandable-case-party-names {
  flex: 1 1;
  margin-right: 10px;
}
.case-detail-container .case-detail-header .caseheader-label .expandable-case-party-names .case-party-see-more-btn {
  padding: 4px 8px;
  font-size: 12px;
  font-weight: 500;
  color: var(--primary-color);
  background-color: transparent;
  border: 1px solid var(--primary-color);
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  vertical-align: middle;
}
.case-detail-container .case-detail-header .caseheader-label h3 {
  margin-right: 10px;
  font-weight: 600;
}
.case-detail-container .case-detail-header .caseheader-label .casedetail-label-pill {
  background: green;
  color: white;
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 12px;
}
.case-detail-container .case-detail-header .casedetail-edit-btn {
  background: #f1f1f1;
  border: none;
  padding: 6px 6px;
  cursor: pointer;
  border-radius: 50px;
  font-size: 14px;
  height: 28px;
  align-items: center;
  flex-shrink: 0;
  gap: 5px;
  padding: 0 12px;
}
.case-detail-container .casedata-details {
  display: flex;
  justify-content: space-between;
  align-items: start;
  margin-top: 10px;
}
.case-detail-container .casedata-details .case-info-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(250px, 1fr));
  gap: 7px;
  padding-inline: 20px;
  padding-bottom: 20px;
  width: 70%;
}
.case-detail-container .casedata-details .case-info-grid > div {
  line-height: 1.3rem;
}
.case-detail-container .casedata-details .case-info-grid .case-det-grid {
  font-size: 16px;
}
.case-detail-container .casedata-details .case-sidebar {
  float: right;
  background: #e2e8f0;
  padding: 15px;
  border-radius: 6px;
  width: 21%;
  min-width: 100px;
}
.case-detail-container .casedata-details .case-sidebar .assignment-info {
  background: white;
  padding: 10px;
  border-radius: 4px;
  margin-bottom: 15px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}
.case-detail-container .casedata-details .case-sidebar .assignment-info .assignment-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.case-detail-container .casedata-details .case-sidebar .assignment-info .assignment-header p {
  margin: 0;
  font-size: 14px;
}
.case-detail-container .casedata-details .case-sidebar .assignment-info .assignment-header p strong {
  color: #374151;
}
.case-detail-container .casedata-details .case-sidebar .assignment-info .assignment-header .assignment-actions {
  display: flex;
  gap: 5px;
}
.case-detail-container .casedata-details .case-sidebar .assignment-info .assignment-header .assignment-actions button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 18px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.75rem;
}
.case-detail-container .casedata-details .case-sidebar .assignment-info .assignment-header .assignment-actions button.case-edit-icon-btn {
  background-color: #3b82f6;
  color: white;
}
.case-detail-container .casedata-details .case-sidebar .assignment-info .assignment-header .assignment-actions button.case-edit-icon-btn:hover {
  background-color: #2563eb;
}
.case-detail-container .casedata-details .case-sidebar .assignment-info .assignment-header .assignment-actions button.case-delete-icon-btn {
  background-color: #ef4444;
  color: white;
}
.case-detail-container .casedata-details .case-sidebar .assignment-info .assignment-header .assignment-actions button.case-delete-icon-btn:hover {
  background-color: #dc2626;
}
.case-detail-container .casedata-details .case-sidebar .assignment-info .assigned-names {
  color: green;
  font-weight: 500;
  font-size: 0.9rem;
}
.case-detail-container .casedata-details .case-sidebar .assignment-info .assigned-names .assigned-user-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 2px 0;
  margin-bottom: 4px;
}
.case-detail-container .casedata-details .case-sidebar .assignment-info .assigned-names .assigned-user-item .user-link {
  cursor: pointer;
  text-decoration: underline;
  flex: 1 1;
}
.case-detail-container .casedata-details .case-sidebar .assignment-info .assigned-names .assigned-user-item .user-link:hover {
  color: #059669;
}
.case-detail-container .casedata-details .case-sidebar .assignment-info .assigned-names .assigned-user-item .user-name-readonly {
  color: #333;
  cursor: default;
}
.case-detail-container .casedata-details .case-sidebar .assignment-info .assigned-names .assigned-user-item .case-delete-user-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  margin-left: 8px;
  background-color: #ef4444;
  color: white;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  font-size: 10px;
  opacity: 0.7;
}
.case-detail-container .casedata-details .case-sidebar .assignment-info .assigned-names .assigned-user-item .case-delete-user-btn:hover {
  opacity: 1;
  background-color: #dc2626;
}
.case-detail-container .casedata-details .case-sidebar .assignment-info .assigned-names .unassigned-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.case-detail-container .casedata-details .case-sidebar .assignment-info .assigned-names .unassigned-container .case-add-assignment-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  background-color: var(--primary-color);
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 0.8rem;
  cursor: pointer;
  align-self: flex-start;
}
.case-detail-container .casedata-details .case-sidebar .assignment-info .assigned-names .unassigned-container .case-add-assignment-btn:hover {
  background-color: #005a9a;
}
.case-detail-container .casedata-details .case-sidebar .casedecison {
  display: flex;
  align-items: center;
}
.case-detail-container .casedata-details .case-sidebar .casedecison p:first-child {
  margin-right: 5px;
}
.case-detail-container .casedata-details .case-sidebar .next-hearing-date-section {
  background: white;
  padding: 10px;
  border-radius: 4px;
  margin-bottom: 15px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}
.case-detail-container .casedata-details .case-sidebar .next-hearing-date-section > p {
  margin: 0 0 5px 0;
  font-size: 14px;
}
.case-detail-container .casedata-details .case-sidebar .next-hearing-date-section > p strong {
  color: #374151;
}
.case-detail-container .casedata-details .case-sidebar .next-hearing-date-section .next-hearing-display {
  display: flex;
  align-items: center;
  gap: 8px;
}
.case-detail-container .casedata-details .case-sidebar .next-hearing-date-section .next-hearing-display span {
  font-weight: 400;
  font-size: 0.9rem;
}
.case-detail-container .casedata-details .case-sidebar .next-hearing-date-section .next-hearing-display span.custom-updated-date {
  color: #059669;
}
.case-detail-container .casedata-details .case-sidebar .next-hearing-date-section .next-hearing-display button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 18px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.75rem;
}
.case-detail-container .casedata-details .case-sidebar .next-hearing-date-section .next-hearing-display button.case-edit-icon-btn {
  background-color: #3b82f6;
  color: white;
}
.case-detail-container .casedata-details .case-sidebar .next-hearing-date-section .next-hearing-display button.case-edit-icon-btn:hover {
  background-color: #2563eb;
}
.case-detail-container .casedata-details .case-sidebar .next-hearing-date-section .next-hearing-edit {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.case-detail-container .casedata-details .case-sidebar .next-hearing-date-section .next-hearing-edit .next-hearing-date-input {
  padding: 8px 10px;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  font-size: 14px;
  transition: all 0.2s ease-in-out;
  cursor: pointer;
}
.case-detail-container .casedata-details .case-sidebar .next-hearing-date-section .next-hearing-edit .next-hearing-date-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);
}
.case-detail-container .casedata-details .case-sidebar .next-hearing-date-section .next-hearing-edit .next-hearing-date-input:hover {
  border-color: #3b82f6;
}
.case-detail-container .casedata-details .case-sidebar .next-hearing-date-section .next-hearing-edit .next-hearing-actions {
  display: flex;
  gap: 5px;
  justify-content: flex-end;
}
.case-detail-container .casedata-details .case-sidebar .next-hearing-date-section .next-hearing-edit .next-hearing-actions button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 18px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.75rem;
  transition: all 0.2s ease-in-out;
}
.case-detail-container .casedata-details .case-sidebar .next-hearing-date-section .next-hearing-edit .next-hearing-actions button.case-save-icon-btn {
  background-color: #10b981;
  color: white;
}
.case-detail-container .casedata-details .case-sidebar .next-hearing-date-section .next-hearing-edit .next-hearing-actions button.case-save-icon-btn:hover {
  background-color: #059669;
  transform: translateY(-1px);
}
.case-detail-container .casedata-details .case-sidebar .next-hearing-date-section .next-hearing-edit .next-hearing-actions button.case-cancel-icon-btn {
  background-color: #6b7280;
  color: white;
}
.case-detail-container .casedata-details .case-sidebar .next-hearing-date-section .next-hearing-edit .next-hearing-actions button.case-cancel-icon-btn:hover {
  background-color: #4b5563;
  transform: translateY(-1px);
}

.appeal-info {
  background: #f4f6f8;
  padding-inline: 20px;
  padding-block: 10px;
  border-radius: 4px;
  margin-bottom: 15px;
  justify-content: space-between;
  display: flex;
  align-items: start;
  margin-top: 15px;
}
.appeal-info .appeal-data .appeal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.appeal-info .appeal-data .appeal-header p {
  margin: 0;
  font-size: 15px;
}
.appeal-info .appeal-data .appeal-header p strong {
  color: #374151;
}
.appeal-info .appeal-data .appeal-header .appeal-actions {
  display: flex;
  gap: 5px;
}
.appeal-info .appeal-data .appeal-header .appeal-actions button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 18px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.75rem;
}
.appeal-info .appeal-data .appeal-header .appeal-actions button.case-edit-icon-btn {
  background-color: #3b82f6;
  color: white;
}
.appeal-info .appeal-data .appeal-header .appeal-actions button.case-edit-icon-btn:hover {
  background-color: #2563eb;
}
.appeal-info .appeal-data .appeal-header .appeal-actions button.case-delete-icon-btn {
  background-color: #ef4444;
  color: white;
}
.appeal-info .appeal-data .appeal-header .appeal-actions button.case-delete-icon-btn:hover {
  background-color: #dc2626;
}
.appeal-info .appeal-data .case-add-appeal-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  background-color: #3b82f6;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 11px;
  cursor: pointer;
  align-self: flex-start;
}
.appeal-info .appeal-data .case-add-appeal-btn:hover {
  background-color: #2563eb;
}
.appeal-info .appeal-data .appeal-edit-container .appeal-input-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 10px;
}
.appeal-info .appeal-data .appeal-edit-container .appeal-input-group .case-appeal-input {
  padding: 6px 8px;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  font-size: 12px;
  transition: all 0.2s ease-in-out;
}
.appeal-info .appeal-data .appeal-edit-container .appeal-input-group .case-appeal-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);
}
.appeal-info .appeal-data .appeal-edit-container .appeal-input-group .case-appeal-input[readonly] {
  background-color: #f9fafb;
  color: #6b7280;
  cursor: not-allowed;
  border-color: #d1d5db;
}
.appeal-info .appeal-data .appeal-edit-container .appeal-input-group .case-appeal-input[readonly]::placeholder {
  color: #9ca3af;
}
.appeal-info .appeal-data .appeal-edit-container .appeal-input-group .appeal-base-date {
  margin-top: 4px;
}
.appeal-info .appeal-data .appeal-edit-container .appeal-input-group .appeal-base-date small {
  color: #6b7280;
  font-size: 10px;
  font-style: italic;
  display: block;
  padding: 2px 4px;
  background-color: #f3f4f6;
  border-radius: 3px;
  border-left: 3px solid #3b82f6;
}
.appeal-info .appeal-data .appeal-edit-container .appeal-edit-actions {
  display: flex;
  gap: 8px;
}
.appeal-info .appeal-data .appeal-edit-container .appeal-edit-actions button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 18px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.75rem;
  transition: all 0.2s ease-in-out;
}
.appeal-info .appeal-data .appeal-edit-container .appeal-edit-actions button.case-save-icon-btn {
  background-color: #10b981;
  color: white;
}
.appeal-info .appeal-data .appeal-edit-container .appeal-edit-actions button.case-save-icon-btn:hover {
  background-color: #059669;
  transform: translateY(-1px);
}
.appeal-info .appeal-data .appeal-edit-container .appeal-edit-actions button.case-cancel-icon-btn {
  background-color: #6b7280;
  color: white;
}
.appeal-info .appeal-data .appeal-edit-container .appeal-edit-actions button.case-cancel-icon-btn:hover {
  background-color: #4b5563;
  transform: translateY(-1px);
}
.appeal-info .appeal-data .appeal-display .appeal-para {
  display: flex;
  gap: 10px;
}
.appeal-info .appeal-data .appeal-display .appeal-para p {
  margin: 4px 0;
  font-size: 14px;
  color: #374151;
}
.appeal-info .appeal-data .appeal-display .appeal-para p strong {
  color: #1f2937;
}
.appeal-info .appeal-data .appeal-display .appeal-para p:last-child {
  color: #059669;
  font-weight: 500;
}
.appeal-info .appeal-data .appeal-display p {
  margin: 4px 0;
  font-size: 14px;
  color: #374151;
}
.appeal-info .appeal-data .appeal-display p strong {
  color: #1f2937;
}
.appeal-info .appeal-data .appeal-display p:last-child {
  color: #059669;
  font-weight: 500;
}
.appeal-info .appeal-data .appeal-display .calculated-date {
  position: relative;
}
.appeal-info .appeal-data .appeal-display .calculated-date::after {
  content: "📅";
  font-size: 10px;
  margin-left: 4px;
  opacity: 0.7;
}
.appeal-info .appeal-information {
  font-size: 0.8rem;
  padding: 7px;
  background-color: white;
}

.case-detail-status-pending {
  background: var(--status-color);
  color: var(--text-color);
  font-size: 12px;
  padding: 3px 6px;
  border-radius: 3px;
}
.case-detail-status-case-disposed {
  background-color: #f0f0f0;
  color: #888;
  pointer-events: none;
  cursor: not-allowed;
  padding: 0px 5px;
  border-radius: 5px;
  display: inline-block;
  font-size: 12px;
}
.case-detail-status-disposed {
  background-color: #f0f0f0;
  color: #888;
  pointer-events: none;
  cursor: not-allowed;
  padding: 0px 5px;
  border-radius: 5px;
  display: inline-block;
  font-size: 12px;
}

@media (max-width: 1024px) {
  .case-detail-container .casedata-details {
    flex-direction: column;
    align-items: stretch;
  }
  .case-detail-container .casedata-details .case-info-grid {
    width: 100%;
    grid-template-columns: 1fr;
    padding: 10px;
  }
  .case-detail-container .casedata-details .case-sidebar {
    width: 100%;
    margin-top: 20px;
    float: none;
  }
  .case-detail-container .case-detail-header {
    flex-direction: column;
    align-items: flex-start;
  }
  .case-detail-container .case-detail-header .caseheader-label {
    padding: 10px;
  }
  .case-detail-container .case-detail-header .caseheader-label h3 {
    margin-bottom: 10px;
  }
  .case-detail-container .case-detail-header .caseheader-label .casedetail-label-pill {
    margin-top: 5px;
    margin-left: 0;
    margin-right: 10px;
  }
  .case-detail-container .case-detail-header .casedetail-edit-btn {
    margin-top: 10px;
    align-self: flex-end;
  }
}
@media (max-width: 600px) {
  .case-detail-container {
    padding: 10px;
  }
  .case-detail-container .case-detail-header .caseheader-label h3 {
    font-size: 16px;
  }
  .case-detail-container .case-detail-header .casedetail-label-pill {
    font-size: 10px;
    padding: 4px 8px;
    height: auto;
    width: auto;
  }
  .case-detail-container .case-detail-header .casedetail-edit-btn {
    font-size: 12px;
    padding: 4px 10px;
  }
  .case-detail-container .case-info-grid {
    font-size: 14px;
  }
  .case-detail-container .case-sidebar {
    font-size: 14px;
  }
  .case-detail-container .case-sidebar .assignment-info .assignment-header,
  .case-detail-container .case-sidebar .assignment-info .appeal-header,
  .case-detail-container .case-sidebar .appeal-info .assignment-header,
  .case-detail-container .case-sidebar .appeal-info .appeal-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  .case-detail-container .case-sidebar .assignment-info .appeal-edit-container .appeal-input-group .case-appeal-input,
  .case-detail-container .case-sidebar .appeal-info .appeal-edit-container .appeal-input-group .case-appeal-input {
    font-size: 14px;
    padding: 8px;
  }
  .case-detail-container .case-sidebar .assignment-info .appeal-edit-container .appeal-input-group .appeal-base-date small,
  .case-detail-container .case-sidebar .appeal-info .appeal-edit-container .appeal-input-group .appeal-base-date small {
    font-size: 11px;
  }
  .case-detail-container .case-sidebar .assignment-info .appeal-edit-container .appeal-edit-actions,
  .case-detail-container .case-sidebar .appeal-info .appeal-edit-container .appeal-edit-actions {
    flex-direction: row;
    justify-content: center;
  }
  .case-detail-container .case-sidebar .assignment-info .appeal-edit-container .appeal-edit-actions button,
  .case-detail-container .case-sidebar .appeal-info .appeal-edit-container .appeal-edit-actions button {
    width: 40px;
    height: 28px;
  }
}
.office-ref {
  display: flex;
  gap: 10px;
  align-items: flex-start;
}

.case-add-label-btn {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.25rem 0.5rem;
  background-color: var(--primary-color);
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 0.8rem;
  cursor: pointer;
  flex-shrink: 0;
  height: 28px;
  margin-top: 0;
  white-space: nowrap;
}
.case-add-label-btn:hover {
  background-color: #005a9a;
}

.case-office-ref-container .case-add-office-ref-btn {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.25rem 0.5rem;
  background-color: var(--primary-color);
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 0.8rem;
  cursor: pointer;
}
.case-office-ref-container .case-add-office-ref-btn:hover {
  background-color: #005a9a;
}
.case-office-ref-container .case-office-ref-edit,
.case-office-ref-container .case-office-ref-display {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.case-office-ref-container .case-office-ref-edit .case-office-ref-input,
.case-office-ref-container .case-office-ref-display .case-office-ref-input {
  padding: 0.25rem 0.5rem;
  border: 1px solid var(--border-light);
  border-radius: 4px;
  font-size: 0.875rem;
  flex: 1 1;
}
.case-office-ref-container .case-office-ref-edit .case-office-ref-actions,
.case-office-ref-container .case-office-ref-display .case-office-ref-actions {
  display: flex;
  gap: 0.25rem;
}
.case-office-ref-container .case-office-ref-edit .case-office-ref-actions button,
.case-office-ref-container .case-office-ref-display .case-office-ref-actions button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 18px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.75rem;
}
.case-office-ref-container .case-office-ref-edit .case-office-ref-actions button.case-save-icon-btn,
.case-office-ref-container .case-office-ref-display .case-office-ref-actions button.case-save-icon-btn {
  background-color: var(--success-color);
  color: white;
}
.case-office-ref-container .case-office-ref-edit .case-office-ref-actions button.case-edit-icon-btn,
.case-office-ref-container .case-office-ref-display .case-office-ref-actions button.case-edit-icon-btn {
  background-color: #3b82f6;
  color: white;
}
.case-office-ref-container .case-office-ref-edit .case-office-ref-actions button.case-delete-icon-btn,
.case-office-ref-container .case-office-ref-display .case-office-ref-actions button.case-delete-icon-btn {
  background-color: #ef4444;
  color: white;
}
.case-office-ref-container .case-office-ref-edit .case-office-ref-actions button.case-cancel-icon-btn,
.case-office-ref-container .case-office-ref-display .case-office-ref-actions button.case-cancel-icon-btn {
  background-color: var(--text-light);
  color: white;
}
.case-office-ref-container .case-office-ref-edit .case-office-ref-actions button:hover,
.case-office-ref-container .case-office-ref-display .case-office-ref-actions button:hover {
  opacity: 0.8;
}

.no-data-message {
  text-align: center;
  padding: 20px;
  color: #6b7280;
}
.no-data-message h3 {
  color: #374151;
  margin-bottom: 10px;
}
.no-data-message p {
  font-size: 14px;
  line-height: 1.5;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  animation: fadeIn 0.2s ease-out;
  padding: 20px;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.reappeal-modal {
  background: white;
  border-radius: 12px;
  width: 100%;
  max-width: 480px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  animation: slideIn 0.3s ease-out;
  overflow: hidden;
}
.reappeal-modal .modal-header {
  padding: 24px 24px 16px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e5e7eb;
}
.reappeal-modal .modal-header h3 {
  margin: 0;
  color: #1f2937;
  font-size: 20px;
  font-weight: 600;
}
.reappeal-modal .modal-header .close-btn {
  background: none;
  border: none;
  font-size: 28px;
  cursor: pointer;
  color: #6b7280;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s ease;
  line-height: 1;
}
.reappeal-modal .modal-header .close-btn:hover {
  background-color: #f3f4f6;
  color: #374151;
}
.reappeal-modal .modal-header .close-btn:active {
  transform: scale(0.95);
}
.reappeal-modal .modal-body {
  padding: 24px;
}
.reappeal-modal .modal-body form {
  display: flex;
  flex-direction: column;
}
.reappeal-modal .modal-body .form-group {
  margin-bottom: 24px;
}
.reappeal-modal .modal-body .form-group:last-of-type {
  margin-bottom: 32px;
}
.reappeal-modal .modal-body .form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  color: #374151;
  font-size: 14px;
}
.reappeal-modal .modal-body .form-group input[type=number] {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #d1d5db;
  border-radius: 8px;
  font-size: 16px;
  transition: all 0.2s ease;
  background-color: white;
  color: #1f2937;
  box-sizing: border-box;
}
.reappeal-modal .modal-body .form-group input[type=number]:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.reappeal-modal .modal-body .form-group input[type=number]::placeholder {
  color: #9ca3af;
}
.reappeal-modal .modal-body .form-group input[type=number]::-webkit-outer-spin-button, .reappeal-modal .modal-body .form-group input[type=number]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.reappeal-modal .modal-body .form-group input[type=number][type=number] {
  -moz-appearance: textfield;
}
.reappeal-modal .modal-body .form-group input[type=text] {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #d1d5db;
  border-radius: 8px;
  font-size: 16px;
  transition: all 0.2s ease;
  background-color: white;
  color: #1f2937;
  box-sizing: border-box;
}
.reappeal-modal .modal-body .form-group input[type=text]:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.reappeal-modal .modal-body .form-group input[type=text]::placeholder {
  color: #9ca3af;
}
.reappeal-modal .modal-body .form-group input[type=text]::-webkit-outer-spin-button, .reappeal-modal .modal-body .form-group input[type=text]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.reappeal-modal .modal-body .form-group .date-select-container {
  display: flex;
  gap: 10px;
  width: 100%;
}
.reappeal-modal .modal-body .form-group select.date-select {
  flex: 1 1;
  padding: 12px 10px;
  border: 2px solid #d1d5db;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.2s ease;
  background-color: white;
  color: #1f2937;
  box-sizing: border-box;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position-x: 95%;
  background-position-y: 50%;
}
.reappeal-modal .modal-body .form-group select.date-select:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.reappeal-modal .modal-body .form-group .calculated-date-display {
  margin-top: 12px;
  padding: 10px;
  background-color: #f3f4f6;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  text-align: center;
  font-size: 14px;
  color: #374151;
}
.reappeal-modal .modal-body .form-group .calculated-date-display strong {
  color: #1d4ed8;
  font-weight: 600;
}
.reappeal-modal .modal-body .form-group .calculated-date {
  padding: 16px;
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  border-radius: 8px;
  font-weight: 600;
  text-align: center;
  font-size: 16px;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
  animation: slideInDate 0.3s ease-out;
}
@keyframes slideInDate {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.reappeal-modal .modal-body .modal-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 0;
}
.reappeal-modal .modal-body .modal-actions button {
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.2s ease;
  min-width: 110px;
}
.reappeal-modal .modal-body .modal-actions button.cancel-btn {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  min-width: 120px;
  transition: all 0.2s ease;
  background-color: #dc2626;
  color: white;
}
.reappeal-modal .modal-body .modal-actions button.cancel-btn:hover {
  background-color: #b91c1c;
}
.reappeal-modal .modal-body .modal-actions button.cancel-btn:active {
  transform: scale(0.98);
}
.reappeal-modal .modal-body .modal-actions button.submit-btn {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  min-width: 120px;
  transition: all 0.2s ease;
  background-color: #16a34a;
  color: white;
}
.reappeal-modal .modal-body .modal-actions button.submit-btn:hover:not(:disabled) {
  background-color: #15803d;
}
.reappeal-modal .modal-body .modal-actions button.submit-btn:active:not(:disabled) {
  transform: translateY(0);
}
.reappeal-modal .modal-body .modal-actions button.submit-btn:disabled {
  background: #d1d5db;
  cursor: not-allowed;
  opacity: 0.6;
  transform: none;
  box-shadow: none;
}

@keyframes slideIn {
  from {
    transform: translateY(-30px) scale(0.95);
    opacity: 0;
  }
  to {
    transform: translateY(0) scale(1);
    opacity: 1;
  }
}
@media (max-width: 768px) {
  .reappeal-modal {
    width: 95%;
    margin: 20px;
  }
  .reappeal-modal .modal-body .form-group .date-select-container {
    flex-direction: column;
    gap: 8px;
  }
  .reappeal-modal .modal-body .modal-actions {
    flex-direction: column;
  }
  .reappeal-modal .modal-body .modal-actions button {
    width: 100%;
    margin-bottom: 8px;
  }
  .reappeal-modal .modal-body .modal-actions button:last-child {
    margin-bottom: 0;
  }
}
/* Status Edit Styles */
.status-display-group {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  vertical-align: middle;
}

.status-edit-trigger-btn {
  background: transparent;
  border: none;
  padding: 4px;
  cursor: pointer;
  border-radius: 4px;
  font-size: 14px;
  color: #6b7280;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}
.status-edit-trigger-btn:hover {
  background-color: #f3f4f6;
  color: #3b82f6;
}

.status-edit-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 8px;
  padding: 12px;
  background-color: #f9fafb;
  border-radius: 6px;
  border: 1px solid #e5e7eb;
  width: fit-content;
  min-width: 200px;
}

.status-toggle-group {
  display: flex;
  align-items: center;
  gap: 10px;
}

.status-label-text {
  font-size: 14px;
  font-weight: 500;
  color: #374151;
}

/* Small Toggle Switch */
.switch-small {
  position: relative;
  display: inline-block;
  width: 36px;
  height: 20px;
}

.switch-small input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider-small {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: 34px;
}

.slider-small:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}

input:checked + .slider-small {
  background-color: #3b82f6; /* Primary Blue */
}

input:focus + .slider-small {
  box-shadow: 0 0 1px #3b82f6;
}

input:checked + .slider-small:before {
  transform: translateX(16px);
}

.status-date-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.status-date-group label {
  font-size: 12px;
  font-weight: 600;
  color: #4b5563;
}
.status-date-group .status-date-input {
  padding: 6px 10px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  font-size: 13px;
  width: 100%;
  outline: none;
  transition: border-color 0.2s;
}
.status-date-group .status-date-input:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);
}

.status-actions {
  display: flex;
  gap: 8px;
  margin-top: 4px;
}
.status-actions button {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.2s;
  flex: 1 1;
}
.status-actions .status-save-btn {
  background-color: #10b981;
  color: white;
}
.status-actions .status-save-btn:hover {
  background-color: #059669;
}
.status-actions .status-cancel-btn {
  background-color: #ef4444;
  color: white;
}
.status-actions .status-cancel-btn:hover {
  background-color: #dc2626;
}`, "",{"version":3,"sources":["webpack://./src/pages/CaseDetails/CaseDetails.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EAEE,gBAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,oBAAA;AACJ;AACI;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;EACA,WAAA;AACN;AAAM;EACE,SAAA;EACA,kBAAA;AAER;AADQ;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,2BAAA;EACA,6BAAA;EACA,sCAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;AAGV;AACM;EACE,kBAAA;EACA,gBAAA;AACR;AAEM;EACE,iBAAA;EACA,YAAA;EACA,iBAAA;EAEA,kBAAA;EACA,eAAA;AADR;AAOI;EACE,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;EACA,QAAA;EACA,eAAA;AALN;AASE;EACE,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,gBAAA;AAPJ;AASI;EACE,aAAA;EACA,oDAAA;EACA,QAAA;EACA,oBAAA;EACA,oBAAA;EAEA,UAAA;AARN;AAUM;EACE,mBAAA;AARR;AAUM;EACE,eAAA;AARR;AAYI;EACE,YAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;AAVN;AAYM;EACE,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,wCAAA;AAVR;AAYQ;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAVV;AAYU;EACE,SAAA;EACA,eAAA;AAVZ;AAYY;EACE,cAAA;AAVd;AAcU;EACE,aAAA;EACA,QAAA;AAZZ;AAcY;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;AAZd;AAcc;EACE,yBAAA;EACA,YAAA;AAZhB;AAcgB;EACE,yBAAA;AAZlB;AAgBc;EACE,yBAAA;EACA,YAAA;AAdhB;AAgBgB;EACE,yBAAA;AAdlB;AAqBQ;EACE,YAAA;EACA,gBAAA;EACA,iBAAA;AAnBV;AAqBU;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,cAAA;EACA,kBAAA;AAnBZ;AAqBY;EACE,eAAA;EACA,0BAAA;EACA,SAAA;AAnBd;AAqBc;EACE,cAAA;AAnBhB;AAsBY;EACE,WAAA;EACA,eAAA;AApBd;AAuBY;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;AArBd;AAuBc;EACE,UAAA;EACA,yBAAA;AArBhB;AA0BU;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAxBZ;AA0BY;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,sCAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,sBAAA;AAxBd;AA0Bc;EACE,yBAAA;AAxBhB;AAiCM;EACE,aAAA;EACA,mBAAA;AA/BR;AAiCQ;EACE,iBAAA;AA/BV;AAoCM;EACE,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,wCAAA;AAlCR;AAoCQ;EACE,iBAAA;EACA,eAAA;AAlCV;AAoCU;EACE,cAAA;AAlCZ;AAsCQ;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AApCV;AAsCU;EACE,gBAAA;EACA,iBAAA;AApCZ;AAuCY;EACE,cAAA;AArCd;AAyCU;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;AAvCZ;AAyCY;EACE,yBAAA;EACA,YAAA;AAvCd;AAyCc;EACE,yBAAA;AAvChB;AA6CQ;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AA3CV;AA6CU;EACE,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,gCAAA;EACA,eAAA;AA3CZ;AA6CY;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AA3Cd;AA8CY;EACE,qBAAA;AA5Cd;AAgDU;EACE,aAAA;EACA,QAAA;EACA,yBAAA;AA9CZ;AAgDY;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gCAAA;AA9Cd;AAgDc;EACE,yBAAA;EACA,YAAA;AA9ChB;AAgDgB;EACE,yBAAA;EACA,2BAAA;AA9ClB;AAkDc;EACE,yBAAA;EACA,YAAA;AAhDhB;AAkDgB;EACE,yBAAA;EACA,2BAAA;AAhDlB;;AA0DA;EACE,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;AAvDF;AA2DI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAzDN;AA4DM;EACE,SAAA;EACA,eAAA;AA1DR;AA4DQ;EACE,cAAA;AA1DV;AA8DM;EACE,aAAA;EACA,QAAA;AA5DR;AA8DQ;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;AA5DV;AA8DU;EACE,yBAAA;EACA,YAAA;AA5DZ;AA8DY;EACE,yBAAA;AA5Dd;AAgEU;EACE,yBAAA;EACA,YAAA;AA9DZ;AAgEY;EACE,yBAAA;AA9Dd;AAqEI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,sBAAA;AAnEN;AAqEM;EACE,yBAAA;AAnER;AAwEM;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,mBAAA;AAtER;AAwEQ;EACE,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,gCAAA;AAtEV;AAwEU;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AAtEZ;AAyEU;EACE,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,qBAAA;AAvEZ;AAyEY;EACE,cAAA;AAvEd;AA4EQ;EACE,eAAA;AA1EV;AA4EU;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,8BAAA;AA1EZ;AA+EM;EACE,aAAA;EACA,QAAA;AA7ER;AA+EQ;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gCAAA;AA7EV;AA+EU;EACE,yBAAA;EACA,YAAA;AA7EZ;AA+EY;EACE,yBAAA;EACA,2BAAA;AA7Ed;AAiFU;EACE,yBAAA;EACA,YAAA;AA/EZ;AAiFY;EACE,yBAAA;EACA,2BAAA;AA/Ed;AAuFM;EACE,aAAA;EACA,SAAA;AArFR;AAsFQ;EACE,aAAA;EACA,eAAA;EACA,cAAA;AApFV;AAsFU;EACE,cAAA;AApFZ;AAuFU;EACE,cAAA;EACA,gBAAA;AArFZ;AAyFM;EACE,aAAA;EACA,eAAA;EACA,cAAA;AAvFR;AAyFQ;EACE,cAAA;AAvFV;AA0FQ;EACE,cAAA;EACA,gBAAA;AAxFV;AA6FM;EACE,kBAAA;AA3FR;AA6FQ;EACE,aAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;AA3FV;AAgGE;EACE,iBAAA;EACA,YAAA;EACA,uBAAA;AA9FJ;;AAmGE;EAEE,+BAAA;EACA,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAjGJ;AAoGE;EACE,yBAAA;EACA,WAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EAEA,eAAA;AAnGJ;AAqGE;EACE,yBAAA;EACA,WAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EAEA,eAAA;AApGJ;;AAyGA;EAEI;IACE,sBAAA;IACA,oBAAA;EAvGJ;EAyGI;IACE,WAAA;IACA,0BAAA;IACA,aAAA;EAvGN;EA0GI;IACE,WAAA;IACA,gBAAA;IACA,WAAA;EAxGN;EA4GE;IACE,sBAAA;IACA,uBAAA;EA1GJ;EA4GI;IACE,aAAA;EA1GN;EA4GM;IACE,mBAAA;EA1GR;EA6GM;IACE,eAAA;IACA,cAAA;IACA,kBAAA;EA3GR;EA+GI;IACE,gBAAA;IACA,oBAAA;EA7GN;AACF;AAkHA;EACE;IACE,aAAA;EAhHF;EAmHI;IACE,eAAA;EAjHN;EAoHI;IACE,eAAA;IACA,gBAAA;IACA,YAAA;IACA,WAAA;EAlHN;EAqHI;IACE,eAAA;IACA,iBAAA;EAnHN;EAuHE;IACE,eAAA;EArHJ;EAwHE;IACE,eAAA;EAtHJ;EA0HM;;;;IAEE,sBAAA;IACA,uBAAA;IACA,QAAA;EAtHR;EA2HU;;IACE,eAAA;IACA,YAAA;EAxHZ;EA4HY;;IACE,eAAA;EAzHd;EA8HQ;;IACE,mBAAA;IACA,uBAAA;EA3HV;EA6HU;;IACE,WAAA;IACA,YAAA;EA1HZ;AACF;AAkIA;EACE,aAAA;EACA,SAAA;EACA,uBAAA;AAhIF;;AAmIA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;EACA,sCAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EAEA,cAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AAjIF;AAkIE;EACE,yBAAA;AAhIJ;;AAuIE;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;EACA,sCAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AApIJ;AAsII;EACE,yBAAA;AApIN;AAwIE;;EAEE,aAAA;EACA,mBAAA;EACA,WAAA;AAtIJ;AAwII;;EACE,uBAAA;EACA,qCAAA;EACA,kBAAA;EACA,mBAAA;EACA,SAAA;AArIN;AAwII;;EACE,aAAA;EACA,YAAA;AArIN;AAuIM;;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;AApIR;AAsIQ;;EACE,sCAAA;EACA,YAAA;AAnIV;AAsIQ;;EACE,yBAAA;EACA,YAAA;AAnIV;AAsIQ;;EACE,yBAAA;EACA,YAAA;AAnIV;AAsIQ;;EACE,mCAAA;EACA,YAAA;AAnIV;AAsIQ;;EACE,YAAA;AAnIV;;AA6IA;EACE,kBAAA;EACA,aAAA;EACA,cAAA;AA1IF;AA4IE;EACE,cAAA;EACA,mBAAA;AA1IJ;AA6IE;EACE,eAAA;EACA,gBAAA;AA3IJ;;AAgJA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,+BAAA;EACA,aAAA;AA7IF;;AAgJA;EACE;IACE,UAAA;EA7IF;EA+IA;IACE,UAAA;EA7IF;AACF;AAgJA;EACE,iBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,2CAAA;EACA,gCAAA;EACA,gBAAA;AA9IF;AAgJE;EACE,4BAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gCAAA;AA9IJ;AAgJI;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AA9IN;AAiJI;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;AA/IN;AAiJM;EACE,yBAAA;EACA,cAAA;AA/IR;AAkJM;EACE,sBAAA;AAhJR;AAqJE;EACE,aAAA;AAnJJ;AAqJI;EACE,aAAA;EACA,sBAAA;AAnJN;AAsJI;EACE,mBAAA;AApJN;AAsJM;EACE,mBAAA;AApJR;AAuJM;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AArJR;AAwJM;EACE,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,uBAAA;EACA,cAAA;EACA,sBAAA;AAtJR;AAwJQ;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AAtJV;AAyJQ;EACE,cAAA;AAvJV;AA0JQ;EAEE,wBAAA;EACA,SAAA;AAzJV;AA4JQ;EACE,0BAAA;AA1JV;AA8JM;EACE,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,uBAAA;EACA,cAAA;EACA,sBAAA;AA5JR;AA8JQ;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AA5JV;AA+JQ;EACE,cAAA;AA7JV;AAgKQ;EAEE,wBAAA;EACA,SAAA;AA/JV;AAoKM;EACE,aAAA;EACA,SAAA;EACA,WAAA;AAlKR;AAqKM;EACE,SAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,uBAAA;EACA,cAAA;EACA,sBAAA;EACA,wBAAA;EACA,qBAAA;EACA,yDAAA;EACA,4BAAA;EACA,0BAAA;EACA,0BAAA;AAnKR;AAqKQ;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AAnKV;AAuKM;EACE,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AArKR;AAuKQ;EACE,cAAA;EACA,gBAAA;AArKV;AAyKM;EACE,aAAA;EACA,6DAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,8CAAA;EACA,oCAAA;AAvKR;AA0KM;EACE;IACE,UAAA;IACA,4BAAA;EAxKR;EA0KM;IACE,UAAA;IACA,wBAAA;EAxKR;AACF;AA4KI;EACE,aAAA;EACA,SAAA;EACA,yBAAA;EACA,aAAA;AA1KN;AA4KM;EACE,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,gBAAA;AA1KR;AA4KQ;EACE,uBAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,yBAAA;EACA,YAAA;AA1KV;AA4KU;EACE,yBAAA;AA1KZ;AA6KU;EACE,sBAAA;AA3KZ;AA+KQ;EACE,uBAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,yBAAA;EACA,YAAA;AA7KV;AA+KU;EACE,yBAAA;AA7KZ;AAgLU;EACE,wBAAA;AA9KZ;AAiLU;EACE,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AA/KZ;;AAuLA;EACE;IACE,wCAAA;IACA,UAAA;EApLF;EAsLA;IACE,iCAAA;IACA,UAAA;EApLF;AACF;AAwLA;EACE;IACE,UAAA;IACA,YAAA;EAtLF;EA0LM;IACE,sBAAA;IACA,QAAA;EAxLR;EA4LI;IACE,sBAAA;EA1LN;EA4LM;IACE,WAAA;IACA,kBAAA;EA1LR;EA4LQ;IACE,gBAAA;EA1LV;AACF;AAiMA,uBAAA;AACA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,sBAAA;AA/LF;;AAkMA;EACE,uBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;AA/LF;AAiME;EACE,yBAAA;EACA,cAAA;AA/LJ;;AAmMA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AAhMF;;AAmMA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAhMF;;AAmMA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAhMF;;AAmMA,wBAAA;AACA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;AAhMF;;AAmMA;EACE,UAAA;EACA,QAAA;EACA,SAAA;AAhMF;;AAmMA;EACE,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;AAhMF;;AAmMA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;AAhMF;;AAmMA;EACE,yBAAA,EAAA,iBAAA;AAhMF;;AAmMA;EACE,2BAAA;AAhMF;;AAmMA;EACE,2BAAA;AAhMF;;AAmMA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAhMF;AAkME;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAhMJ;AAmME;EACE,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;EACA,aAAA;EACA,6BAAA;AAjMJ;AAmMI;EACE,qBAAA;EACA,6CAAA;AAjMN;;AAsMA;EACE,aAAA;EACA,QAAA;EACA,eAAA;AAnMF;AAqME;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,iCAAA;EACA,SAAA;AAnMJ;AAsME;EACE,yBAAA;EACA,YAAA;AApMJ;AAsMI;EACE,yBAAA;AApMN;AAwME;EACE,yBAAA;EACA,YAAA;AAtMJ;AAwMI;EACE,yBAAA;AAtMN","sourcesContent":["@charset \"UTF-8\";\n.case-detail-container {\n  background: #fff;\n}\n.case-detail-container .case-detail-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding-bottom: 10px;\n}\n.case-detail-container .case-detail-header .caseheader-label {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 10px;\n  padding-left: 20px;\n  width: 100%;\n}\n.case-detail-container .case-detail-header .caseheader-label .expandable-case-party-names {\n  flex: 1;\n  margin-right: 10px;\n}\n.case-detail-container .case-detail-header .caseheader-label .expandable-case-party-names .case-party-see-more-btn {\n  padding: 4px 8px;\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--primary-color);\n  background-color: transparent;\n  border: 1px solid var(--primary-color);\n  border-radius: 12px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  vertical-align: middle;\n}\n.case-detail-container .case-detail-header .caseheader-label h3 {\n  margin-right: 10px;\n  font-weight: 600;\n}\n.case-detail-container .case-detail-header .caseheader-label .casedetail-label-pill {\n  background: green;\n  color: white;\n  padding: 5px 10px;\n  border-radius: 4px;\n  font-size: 12px;\n}\n.case-detail-container .case-detail-header .casedetail-edit-btn {\n  background: #f1f1f1;\n  border: none;\n  padding: 6px 6px;\n  cursor: pointer;\n  border-radius: 50px;\n  font-size: 14px;\n  height: 28px;\n  align-items: center;\n  flex-shrink: 0;\n  gap: 5px;\n  padding: 0 12px;\n}\n.case-detail-container .casedata-details {\n  display: flex;\n  justify-content: space-between;\n  align-items: start;\n  margin-top: 10px;\n}\n.case-detail-container .casedata-details .case-info-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(250px, 1fr));\n  gap: 7px;\n  padding-inline: 20px;\n  padding-bottom: 20px;\n  width: 70%;\n}\n.case-detail-container .casedata-details .case-info-grid > div {\n  line-height: 1.3rem;\n}\n.case-detail-container .casedata-details .case-info-grid .case-det-grid {\n  font-size: 16px;\n}\n.case-detail-container .casedata-details .case-sidebar {\n  float: right;\n  background: #e2e8f0;\n  padding: 15px;\n  border-radius: 6px;\n  width: 21%;\n  min-width: 100px;\n}\n.case-detail-container .casedata-details .case-sidebar .assignment-info {\n  background: white;\n  padding: 10px;\n  border-radius: 4px;\n  margin-bottom: 15px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n.case-detail-container .casedata-details .case-sidebar .assignment-info .assignment-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 10px;\n}\n.case-detail-container .casedata-details .case-sidebar .assignment-info .assignment-header p {\n  margin: 0;\n  font-size: 14px;\n}\n.case-detail-container .casedata-details .case-sidebar .assignment-info .assignment-header p strong {\n  color: #374151;\n}\n.case-detail-container .casedata-details .case-sidebar .assignment-info .assignment-header .assignment-actions {\n  display: flex;\n  gap: 5px;\n}\n.case-detail-container .casedata-details .case-sidebar .assignment-info .assignment-header .assignment-actions button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 18px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.75rem;\n}\n.case-detail-container .casedata-details .case-sidebar .assignment-info .assignment-header .assignment-actions button.case-edit-icon-btn {\n  background-color: #3b82f6;\n  color: white;\n}\n.case-detail-container .casedata-details .case-sidebar .assignment-info .assignment-header .assignment-actions button.case-edit-icon-btn:hover {\n  background-color: #2563eb;\n}\n.case-detail-container .casedata-details .case-sidebar .assignment-info .assignment-header .assignment-actions button.case-delete-icon-btn {\n  background-color: #ef4444;\n  color: white;\n}\n.case-detail-container .casedata-details .case-sidebar .assignment-info .assignment-header .assignment-actions button.case-delete-icon-btn:hover {\n  background-color: #dc2626;\n}\n.case-detail-container .casedata-details .case-sidebar .assignment-info .assigned-names {\n  color: green;\n  font-weight: 500;\n  font-size: 0.9rem;\n}\n.case-detail-container .casedata-details .case-sidebar .assignment-info .assigned-names .assigned-user-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 2px 0;\n  margin-bottom: 4px;\n}\n.case-detail-container .casedata-details .case-sidebar .assignment-info .assigned-names .assigned-user-item .user-link {\n  cursor: pointer;\n  text-decoration: underline;\n  flex: 1;\n}\n.case-detail-container .casedata-details .case-sidebar .assignment-info .assigned-names .assigned-user-item .user-link:hover {\n  color: #059669;\n}\n.case-detail-container .casedata-details .case-sidebar .assignment-info .assigned-names .assigned-user-item .user-name-readonly {\n  color: #333;\n  cursor: default;\n}\n.case-detail-container .casedata-details .case-sidebar .assignment-info .assigned-names .assigned-user-item .case-delete-user-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  margin-left: 8px;\n  background-color: #ef4444;\n  color: white;\n  border: none;\n  border-radius: 50%;\n  cursor: pointer;\n  font-size: 10px;\n  opacity: 0.7;\n}\n.case-detail-container .casedata-details .case-sidebar .assignment-info .assigned-names .assigned-user-item .case-delete-user-btn:hover {\n  opacity: 1;\n  background-color: #dc2626;\n}\n.case-detail-container .casedata-details .case-sidebar .assignment-info .assigned-names .unassigned-container {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.case-detail-container .casedata-details .case-sidebar .assignment-info .assigned-names .unassigned-container .case-add-assignment-btn {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 8px;\n  background-color: var(--primary-color);\n  color: white;\n  border: none;\n  border-radius: 4px;\n  font-size: 0.8rem;\n  cursor: pointer;\n  align-self: flex-start;\n}\n.case-detail-container .casedata-details .case-sidebar .assignment-info .assigned-names .unassigned-container .case-add-assignment-btn:hover {\n  background-color: #005a9a;\n}\n.case-detail-container .casedata-details .case-sidebar .casedecison {\n  display: flex;\n  align-items: center;\n}\n.case-detail-container .casedata-details .case-sidebar .casedecison p:first-child {\n  margin-right: 5px;\n}\n.case-detail-container .casedata-details .case-sidebar .next-hearing-date-section {\n  background: white;\n  padding: 10px;\n  border-radius: 4px;\n  margin-bottom: 15px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n.case-detail-container .casedata-details .case-sidebar .next-hearing-date-section > p {\n  margin: 0 0 5px 0;\n  font-size: 14px;\n}\n.case-detail-container .casedata-details .case-sidebar .next-hearing-date-section > p strong {\n  color: #374151;\n}\n.case-detail-container .casedata-details .case-sidebar .next-hearing-date-section .next-hearing-display {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.case-detail-container .casedata-details .case-sidebar .next-hearing-date-section .next-hearing-display span {\n  font-weight: 400;\n  font-size: 0.9rem;\n}\n.case-detail-container .casedata-details .case-sidebar .next-hearing-date-section .next-hearing-display span.custom-updated-date {\n  color: #059669;\n}\n.case-detail-container .casedata-details .case-sidebar .next-hearing-date-section .next-hearing-display button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 18px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.75rem;\n}\n.case-detail-container .casedata-details .case-sidebar .next-hearing-date-section .next-hearing-display button.case-edit-icon-btn {\n  background-color: #3b82f6;\n  color: white;\n}\n.case-detail-container .casedata-details .case-sidebar .next-hearing-date-section .next-hearing-display button.case-edit-icon-btn:hover {\n  background-color: #2563eb;\n}\n.case-detail-container .casedata-details .case-sidebar .next-hearing-date-section .next-hearing-edit {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.case-detail-container .casedata-details .case-sidebar .next-hearing-date-section .next-hearing-edit .next-hearing-date-input {\n  padding: 8px 10px;\n  border: 1px solid #e5e7eb;\n  border-radius: 4px;\n  font-size: 14px;\n  transition: all 0.2s ease-in-out;\n  cursor: pointer;\n}\n.case-detail-container .casedata-details .case-sidebar .next-hearing-date-section .next-hearing-edit .next-hearing-date-input:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);\n}\n.case-detail-container .casedata-details .case-sidebar .next-hearing-date-section .next-hearing-edit .next-hearing-date-input:hover {\n  border-color: #3b82f6;\n}\n.case-detail-container .casedata-details .case-sidebar .next-hearing-date-section .next-hearing-edit .next-hearing-actions {\n  display: flex;\n  gap: 5px;\n  justify-content: flex-end;\n}\n.case-detail-container .casedata-details .case-sidebar .next-hearing-date-section .next-hearing-edit .next-hearing-actions button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 18px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.75rem;\n  transition: all 0.2s ease-in-out;\n}\n.case-detail-container .casedata-details .case-sidebar .next-hearing-date-section .next-hearing-edit .next-hearing-actions button.case-save-icon-btn {\n  background-color: #10b981;\n  color: white;\n}\n.case-detail-container .casedata-details .case-sidebar .next-hearing-date-section .next-hearing-edit .next-hearing-actions button.case-save-icon-btn:hover {\n  background-color: #059669;\n  transform: translateY(-1px);\n}\n.case-detail-container .casedata-details .case-sidebar .next-hearing-date-section .next-hearing-edit .next-hearing-actions button.case-cancel-icon-btn {\n  background-color: #6b7280;\n  color: white;\n}\n.case-detail-container .casedata-details .case-sidebar .next-hearing-date-section .next-hearing-edit .next-hearing-actions button.case-cancel-icon-btn:hover {\n  background-color: #4b5563;\n  transform: translateY(-1px);\n}\n\n.appeal-info {\n  background: #f4f6f8;\n  padding-inline: 20px;\n  padding-block: 10px;\n  border-radius: 4px;\n  margin-bottom: 15px;\n  justify-content: space-between;\n  display: flex;\n  align-items: start;\n  margin-top: 15px;\n}\n.appeal-info .appeal-data .appeal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.appeal-info .appeal-data .appeal-header p {\n  margin: 0;\n  font-size: 15px;\n}\n.appeal-info .appeal-data .appeal-header p strong {\n  color: #374151;\n}\n.appeal-info .appeal-data .appeal-header .appeal-actions {\n  display: flex;\n  gap: 5px;\n}\n.appeal-info .appeal-data .appeal-header .appeal-actions button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 18px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.75rem;\n}\n.appeal-info .appeal-data .appeal-header .appeal-actions button.case-edit-icon-btn {\n  background-color: #3b82f6;\n  color: white;\n}\n.appeal-info .appeal-data .appeal-header .appeal-actions button.case-edit-icon-btn:hover {\n  background-color: #2563eb;\n}\n.appeal-info .appeal-data .appeal-header .appeal-actions button.case-delete-icon-btn {\n  background-color: #ef4444;\n  color: white;\n}\n.appeal-info .appeal-data .appeal-header .appeal-actions button.case-delete-icon-btn:hover {\n  background-color: #dc2626;\n}\n.appeal-info .appeal-data .case-add-appeal-btn {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 8px;\n  background-color: #3b82f6;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  font-size: 11px;\n  cursor: pointer;\n  align-self: flex-start;\n}\n.appeal-info .appeal-data .case-add-appeal-btn:hover {\n  background-color: #2563eb;\n}\n.appeal-info .appeal-data .appeal-edit-container .appeal-input-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-bottom: 10px;\n}\n.appeal-info .appeal-data .appeal-edit-container .appeal-input-group .case-appeal-input {\n  padding: 6px 8px;\n  border: 1px solid #e5e7eb;\n  border-radius: 4px;\n  font-size: 12px;\n  transition: all 0.2s ease-in-out;\n}\n.appeal-info .appeal-data .appeal-edit-container .appeal-input-group .case-appeal-input:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);\n}\n.appeal-info .appeal-data .appeal-edit-container .appeal-input-group .case-appeal-input[readonly] {\n  background-color: #f9fafb;\n  color: #6b7280;\n  cursor: not-allowed;\n  border-color: #d1d5db;\n}\n.appeal-info .appeal-data .appeal-edit-container .appeal-input-group .case-appeal-input[readonly]::placeholder {\n  color: #9ca3af;\n}\n.appeal-info .appeal-data .appeal-edit-container .appeal-input-group .appeal-base-date {\n  margin-top: 4px;\n}\n.appeal-info .appeal-data .appeal-edit-container .appeal-input-group .appeal-base-date small {\n  color: #6b7280;\n  font-size: 10px;\n  font-style: italic;\n  display: block;\n  padding: 2px 4px;\n  background-color: #f3f4f6;\n  border-radius: 3px;\n  border-left: 3px solid #3b82f6;\n}\n.appeal-info .appeal-data .appeal-edit-container .appeal-edit-actions {\n  display: flex;\n  gap: 8px;\n}\n.appeal-info .appeal-data .appeal-edit-container .appeal-edit-actions button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 18px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.75rem;\n  transition: all 0.2s ease-in-out;\n}\n.appeal-info .appeal-data .appeal-edit-container .appeal-edit-actions button.case-save-icon-btn {\n  background-color: #10b981;\n  color: white;\n}\n.appeal-info .appeal-data .appeal-edit-container .appeal-edit-actions button.case-save-icon-btn:hover {\n  background-color: #059669;\n  transform: translateY(-1px);\n}\n.appeal-info .appeal-data .appeal-edit-container .appeal-edit-actions button.case-cancel-icon-btn {\n  background-color: #6b7280;\n  color: white;\n}\n.appeal-info .appeal-data .appeal-edit-container .appeal-edit-actions button.case-cancel-icon-btn:hover {\n  background-color: #4b5563;\n  transform: translateY(-1px);\n}\n.appeal-info .appeal-data .appeal-display .appeal-para {\n  display: flex;\n  gap: 10px;\n}\n.appeal-info .appeal-data .appeal-display .appeal-para p {\n  margin: 4px 0;\n  font-size: 14px;\n  color: #374151;\n}\n.appeal-info .appeal-data .appeal-display .appeal-para p strong {\n  color: #1f2937;\n}\n.appeal-info .appeal-data .appeal-display .appeal-para p:last-child {\n  color: #059669;\n  font-weight: 500;\n}\n.appeal-info .appeal-data .appeal-display p {\n  margin: 4px 0;\n  font-size: 14px;\n  color: #374151;\n}\n.appeal-info .appeal-data .appeal-display p strong {\n  color: #1f2937;\n}\n.appeal-info .appeal-data .appeal-display p:last-child {\n  color: #059669;\n  font-weight: 500;\n}\n.appeal-info .appeal-data .appeal-display .calculated-date {\n  position: relative;\n}\n.appeal-info .appeal-data .appeal-display .calculated-date::after {\n  content: \"📅\";\n  font-size: 10px;\n  margin-left: 4px;\n  opacity: 0.7;\n}\n.appeal-info .appeal-information {\n  font-size: 0.8rem;\n  padding: 7px;\n  background-color: white;\n}\n\n.case-detail-status-pending {\n  background: var(--status-color);\n  color: var(--text-color);\n  font-size: 12px;\n  padding: 3px 6px;\n  border-radius: 3px;\n}\n.case-detail-status-case-disposed {\n  background-color: #f0f0f0;\n  color: #888;\n  pointer-events: none;\n  cursor: not-allowed;\n  padding: 0px 5px;\n  border-radius: 5px;\n  display: inline-block;\n  font-size: 12px;\n}\n.case-detail-status-disposed {\n  background-color: #f0f0f0;\n  color: #888;\n  pointer-events: none;\n  cursor: not-allowed;\n  padding: 0px 5px;\n  border-radius: 5px;\n  display: inline-block;\n  font-size: 12px;\n}\n\n@media (max-width: 1024px) {\n  .case-detail-container .casedata-details {\n    flex-direction: column;\n    align-items: stretch;\n  }\n  .case-detail-container .casedata-details .case-info-grid {\n    width: 100%;\n    grid-template-columns: 1fr;\n    padding: 10px;\n  }\n  .case-detail-container .casedata-details .case-sidebar {\n    width: 100%;\n    margin-top: 20px;\n    float: none;\n  }\n  .case-detail-container .case-detail-header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  .case-detail-container .case-detail-header .caseheader-label {\n    padding: 10px;\n  }\n  .case-detail-container .case-detail-header .caseheader-label h3 {\n    margin-bottom: 10px;\n  }\n  .case-detail-container .case-detail-header .caseheader-label .casedetail-label-pill {\n    margin-top: 5px;\n    margin-left: 0;\n    margin-right: 10px;\n  }\n  .case-detail-container .case-detail-header .casedetail-edit-btn {\n    margin-top: 10px;\n    align-self: flex-end;\n  }\n}\n@media (max-width: 600px) {\n  .case-detail-container {\n    padding: 10px;\n  }\n  .case-detail-container .case-detail-header .caseheader-label h3 {\n    font-size: 16px;\n  }\n  .case-detail-container .case-detail-header .casedetail-label-pill {\n    font-size: 10px;\n    padding: 4px 8px;\n    height: auto;\n    width: auto;\n  }\n  .case-detail-container .case-detail-header .casedetail-edit-btn {\n    font-size: 12px;\n    padding: 4px 10px;\n  }\n  .case-detail-container .case-info-grid {\n    font-size: 14px;\n  }\n  .case-detail-container .case-sidebar {\n    font-size: 14px;\n  }\n  .case-detail-container .case-sidebar .assignment-info .assignment-header,\n  .case-detail-container .case-sidebar .assignment-info .appeal-header,\n  .case-detail-container .case-sidebar .appeal-info .assignment-header,\n  .case-detail-container .case-sidebar .appeal-info .appeal-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n  }\n  .case-detail-container .case-sidebar .assignment-info .appeal-edit-container .appeal-input-group .case-appeal-input,\n  .case-detail-container .case-sidebar .appeal-info .appeal-edit-container .appeal-input-group .case-appeal-input {\n    font-size: 14px;\n    padding: 8px;\n  }\n  .case-detail-container .case-sidebar .assignment-info .appeal-edit-container .appeal-input-group .appeal-base-date small,\n  .case-detail-container .case-sidebar .appeal-info .appeal-edit-container .appeal-input-group .appeal-base-date small {\n    font-size: 11px;\n  }\n  .case-detail-container .case-sidebar .assignment-info .appeal-edit-container .appeal-edit-actions,\n  .case-detail-container .case-sidebar .appeal-info .appeal-edit-container .appeal-edit-actions {\n    flex-direction: row;\n    justify-content: center;\n  }\n  .case-detail-container .case-sidebar .assignment-info .appeal-edit-container .appeal-edit-actions button,\n  .case-detail-container .case-sidebar .appeal-info .appeal-edit-container .appeal-edit-actions button {\n    width: 40px;\n    height: 28px;\n  }\n}\n.office-ref {\n  display: flex;\n  gap: 10px;\n  align-items: flex-start;\n}\n\n.case-add-label-btn {\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n  padding: 0.25rem 0.5rem;\n  background-color: var(--primary-color);\n  color: white;\n  border: none;\n  border-radius: 4px;\n  font-size: 0.8rem;\n  cursor: pointer;\n  flex-shrink: 0;\n  height: 28px;\n  margin-top: 0;\n  white-space: nowrap;\n}\n.case-add-label-btn:hover {\n  background-color: #005a9a;\n}\n\n.case-office-ref-container .case-add-office-ref-btn {\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n  padding: 0.25rem 0.5rem;\n  background-color: var(--primary-color);\n  color: white;\n  border: none;\n  border-radius: 4px;\n  font-size: 0.8rem;\n  cursor: pointer;\n}\n.case-office-ref-container .case-add-office-ref-btn:hover {\n  background-color: #005a9a;\n}\n.case-office-ref-container .case-office-ref-edit,\n.case-office-ref-container .case-office-ref-display {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n.case-office-ref-container .case-office-ref-edit .case-office-ref-input,\n.case-office-ref-container .case-office-ref-display .case-office-ref-input {\n  padding: 0.25rem 0.5rem;\n  border: 1px solid var(--border-light);\n  border-radius: 4px;\n  font-size: 0.875rem;\n  flex: 1;\n}\n.case-office-ref-container .case-office-ref-edit .case-office-ref-actions,\n.case-office-ref-container .case-office-ref-display .case-office-ref-actions {\n  display: flex;\n  gap: 0.25rem;\n}\n.case-office-ref-container .case-office-ref-edit .case-office-ref-actions button,\n.case-office-ref-container .case-office-ref-display .case-office-ref-actions button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 18px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.75rem;\n}\n.case-office-ref-container .case-office-ref-edit .case-office-ref-actions button.case-save-icon-btn,\n.case-office-ref-container .case-office-ref-display .case-office-ref-actions button.case-save-icon-btn {\n  background-color: var(--success-color);\n  color: white;\n}\n.case-office-ref-container .case-office-ref-edit .case-office-ref-actions button.case-edit-icon-btn,\n.case-office-ref-container .case-office-ref-display .case-office-ref-actions button.case-edit-icon-btn {\n  background-color: #3b82f6;\n  color: white;\n}\n.case-office-ref-container .case-office-ref-edit .case-office-ref-actions button.case-delete-icon-btn,\n.case-office-ref-container .case-office-ref-display .case-office-ref-actions button.case-delete-icon-btn {\n  background-color: #ef4444;\n  color: white;\n}\n.case-office-ref-container .case-office-ref-edit .case-office-ref-actions button.case-cancel-icon-btn,\n.case-office-ref-container .case-office-ref-display .case-office-ref-actions button.case-cancel-icon-btn {\n  background-color: var(--text-light);\n  color: white;\n}\n.case-office-ref-container .case-office-ref-edit .case-office-ref-actions button:hover,\n.case-office-ref-container .case-office-ref-display .case-office-ref-actions button:hover {\n  opacity: 0.8;\n}\n\n.no-data-message {\n  text-align: center;\n  padding: 20px;\n  color: #6b7280;\n}\n.no-data-message h3 {\n  color: #374151;\n  margin-bottom: 10px;\n}\n.no-data-message p {\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n  animation: fadeIn 0.2s ease-out;\n  padding: 20px;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n.reappeal-modal {\n  background: white;\n  border-radius: 12px;\n  width: 100%;\n  max-width: 480px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);\n  animation: slideIn 0.3s ease-out;\n  overflow: hidden;\n}\n.reappeal-modal .modal-header {\n  padding: 24px 24px 16px 24px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid #e5e7eb;\n}\n.reappeal-modal .modal-header h3 {\n  margin: 0;\n  color: #1f2937;\n  font-size: 20px;\n  font-weight: 600;\n}\n.reappeal-modal .modal-header .close-btn {\n  background: none;\n  border: none;\n  font-size: 28px;\n  cursor: pointer;\n  color: #6b7280;\n  padding: 0;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: all 0.2s ease;\n  line-height: 1;\n}\n.reappeal-modal .modal-header .close-btn:hover {\n  background-color: #f3f4f6;\n  color: #374151;\n}\n.reappeal-modal .modal-header .close-btn:active {\n  transform: scale(0.95);\n}\n.reappeal-modal .modal-body {\n  padding: 24px;\n}\n.reappeal-modal .modal-body form {\n  display: flex;\n  flex-direction: column;\n}\n.reappeal-modal .modal-body .form-group {\n  margin-bottom: 24px;\n}\n.reappeal-modal .modal-body .form-group:last-of-type {\n  margin-bottom: 32px;\n}\n.reappeal-modal .modal-body .form-group label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 600;\n  color: #374151;\n  font-size: 14px;\n}\n.reappeal-modal .modal-body .form-group input[type=number] {\n  width: 100%;\n  padding: 12px 16px;\n  border: 2px solid #d1d5db;\n  border-radius: 8px;\n  font-size: 16px;\n  transition: all 0.2s ease;\n  background-color: white;\n  color: #1f2937;\n  box-sizing: border-box;\n}\n.reappeal-modal .modal-body .form-group input[type=number]:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n.reappeal-modal .modal-body .form-group input[type=number]::placeholder {\n  color: #9ca3af;\n}\n.reappeal-modal .modal-body .form-group input[type=number]::-webkit-outer-spin-button, .reappeal-modal .modal-body .form-group input[type=number]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n.reappeal-modal .modal-body .form-group input[type=number][type=number] {\n  -moz-appearance: textfield;\n}\n.reappeal-modal .modal-body .form-group input[type=text] {\n  width: 100%;\n  padding: 12px 16px;\n  border: 2px solid #d1d5db;\n  border-radius: 8px;\n  font-size: 16px;\n  transition: all 0.2s ease;\n  background-color: white;\n  color: #1f2937;\n  box-sizing: border-box;\n}\n.reappeal-modal .modal-body .form-group input[type=text]:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n.reappeal-modal .modal-body .form-group input[type=text]::placeholder {\n  color: #9ca3af;\n}\n.reappeal-modal .modal-body .form-group input[type=text]::-webkit-outer-spin-button, .reappeal-modal .modal-body .form-group input[type=text]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n.reappeal-modal .modal-body .form-group .date-select-container {\n  display: flex;\n  gap: 10px;\n  width: 100%;\n}\n.reappeal-modal .modal-body .form-group select.date-select {\n  flex: 1;\n  padding: 12px 10px;\n  border: 2px solid #d1d5db;\n  border-radius: 8px;\n  font-size: 14px;\n  transition: all 0.2s ease;\n  background-color: white;\n  color: #1f2937;\n  box-sizing: border-box;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  background-image: url(\"data:image/svg+xml;utf8,<svg fill='black' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>\");\n  background-repeat: no-repeat;\n  background-position-x: 95%;\n  background-position-y: 50%;\n}\n.reappeal-modal .modal-body .form-group select.date-select:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n.reappeal-modal .modal-body .form-group .calculated-date-display {\n  margin-top: 12px;\n  padding: 10px;\n  background-color: #f3f4f6;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  text-align: center;\n  font-size: 14px;\n  color: #374151;\n}\n.reappeal-modal .modal-body .form-group .calculated-date-display strong {\n  color: #1d4ed8;\n  font-weight: 600;\n}\n.reappeal-modal .modal-body .form-group .calculated-date {\n  padding: 16px;\n  background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n  color: white;\n  border-radius: 8px;\n  font-weight: 600;\n  text-align: center;\n  font-size: 16px;\n  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);\n  animation: slideInDate 0.3s ease-out;\n}\n@keyframes slideInDate {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n.reappeal-modal .modal-body .modal-actions {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n  margin-top: 0;\n}\n.reappeal-modal .modal-body .modal-actions button {\n  padding: 12px 24px;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 600;\n  transition: all 0.2s ease;\n  min-width: 110px;\n}\n.reappeal-modal .modal-body .modal-actions button.cancel-btn {\n  padding: 0.75rem 1.5rem;\n  border: none;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  min-width: 120px;\n  transition: all 0.2s ease;\n  background-color: #dc2626;\n  color: white;\n}\n.reappeal-modal .modal-body .modal-actions button.cancel-btn:hover {\n  background-color: #b91c1c;\n}\n.reappeal-modal .modal-body .modal-actions button.cancel-btn:active {\n  transform: scale(0.98);\n}\n.reappeal-modal .modal-body .modal-actions button.submit-btn {\n  padding: 0.75rem 1.5rem;\n  border: none;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  min-width: 120px;\n  transition: all 0.2s ease;\n  background-color: #16a34a;\n  color: white;\n}\n.reappeal-modal .modal-body .modal-actions button.submit-btn:hover:not(:disabled) {\n  background-color: #15803d;\n}\n.reappeal-modal .modal-body .modal-actions button.submit-btn:active:not(:disabled) {\n  transform: translateY(0);\n}\n.reappeal-modal .modal-body .modal-actions button.submit-btn:disabled {\n  background: #d1d5db;\n  cursor: not-allowed;\n  opacity: 0.6;\n  transform: none;\n  box-shadow: none;\n}\n\n@keyframes slideIn {\n  from {\n    transform: translateY(-30px) scale(0.95);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0) scale(1);\n    opacity: 1;\n  }\n}\n@media (max-width: 768px) {\n  .reappeal-modal {\n    width: 95%;\n    margin: 20px;\n  }\n  .reappeal-modal .modal-body .form-group .date-select-container {\n    flex-direction: column;\n    gap: 8px;\n  }\n  .reappeal-modal .modal-body .modal-actions {\n    flex-direction: column;\n  }\n  .reappeal-modal .modal-body .modal-actions button {\n    width: 100%;\n    margin-bottom: 8px;\n  }\n  .reappeal-modal .modal-body .modal-actions button:last-child {\n    margin-bottom: 0;\n  }\n}\n/* Status Edit Styles */\n.status-display-group {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  vertical-align: middle;\n}\n\n.status-edit-trigger-btn {\n  background: transparent;\n  border: none;\n  padding: 4px;\n  cursor: pointer;\n  border-radius: 4px;\n  font-size: 14px;\n  color: #6b7280;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s;\n}\n.status-edit-trigger-btn:hover {\n  background-color: #f3f4f6;\n  color: #3b82f6;\n}\n\n.status-edit-container {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-top: 8px;\n  padding: 12px;\n  background-color: #f9fafb;\n  border-radius: 6px;\n  border: 1px solid #e5e7eb;\n  width: fit-content;\n  min-width: 200px;\n}\n\n.status-toggle-group {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.status-label-text {\n  font-size: 14px;\n  font-weight: 500;\n  color: #374151;\n}\n\n/* Small Toggle Switch */\n.switch-small {\n  position: relative;\n  display: inline-block;\n  width: 36px;\n  height: 20px;\n}\n\n.switch-small input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.slider-small {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  transition: 0.4s;\n  border-radius: 34px;\n}\n\n.slider-small:before {\n  position: absolute;\n  content: \"\";\n  height: 16px;\n  width: 16px;\n  left: 2px;\n  bottom: 2px;\n  background-color: white;\n  transition: 0.4s;\n  border-radius: 50%;\n}\n\ninput:checked + .slider-small {\n  background-color: #3b82f6; /* Primary Blue */\n}\n\ninput:focus + .slider-small {\n  box-shadow: 0 0 1px #3b82f6;\n}\n\ninput:checked + .slider-small:before {\n  transform: translateX(16px);\n}\n\n.status-date-group {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n.status-date-group label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #4b5563;\n}\n.status-date-group .status-date-input {\n  padding: 6px 10px;\n  border: 1px solid #d1d5db;\n  border-radius: 4px;\n  font-size: 13px;\n  width: 100%;\n  outline: none;\n  transition: border-color 0.2s;\n}\n.status-date-group .status-date-input:focus {\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);\n}\n\n.status-actions {\n  display: flex;\n  gap: 8px;\n  margin-top: 4px;\n}\n.status-actions button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 6px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: background-color 0.2s;\n  flex: 1;\n}\n.status-actions .status-save-btn {\n  background-color: #10b981;\n  color: white;\n}\n.status-actions .status-save-btn:hover {\n  background-color: #059669;\n}\n.status-actions .status-cancel-btn {\n  background-color: #ef4444;\n  color: white;\n}\n.status-actions .status-cancel-btn:hover {\n  background-color: #dc2626;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
